import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group mr-b-0em" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "form-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", _hoisted_3, _toDisplayString(_ctx.props.TextLabel), 1),
      _createVNode(_component_Multiselect, {
        trackby: _ctx.props.trackby,
        valueProp: String(_ctx.props.valueProp),
        label: _ctx.props.label,
        modelValue: _ctx.selectedValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
        placeholder: `${_ctx.$t(_ctx.props.placeholder)}`,
        options: _ctx.props.arrayOptions,
        multiple: true,
        mode: "tags",
        object: true,
        "close-on-select": false,
        "allow-empty": false,
        "deselect-label": "Can't remove this value",
        ref: _ctx.props.refs,
        searchable: true,
        onInput: _ctx.handleSelect
      }, null, 8, ["trackby", "valueProp", "label", "modelValue", "placeholder", "options", "onInput"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$props.v?.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "text-danger",
          key: error.$uid
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ])
  ]))
}